export default __webpack_public_path__ + "static/media/plus.cac2ba87.svg";